export type TableSort<K extends string> = { key: K; direction: "ascending" | "descending" };

export function nextTableSort<K extends string>(current: TableSort<K> | null, key: K): TableSort<K> {
  return { key, direction: current?.key === key && current.direction === "ascending" ? "descending" : "ascending" };
}

const collator = new Intl.Collator(undefined, { sensitivity: "base", numeric: true });

// Sort raw numbers/dates, not formatted labels. Missing values stay last in either direction.
export function sortTableRows<T>(rows: readonly T[], value: (row: T) => string | number | null | undefined,
  direction: "ascending" | "descending"): T[] {
  const missing = (v: unknown) => v == null || v === "" || (typeof v === "number" && !Number.isFinite(v));
  return [...rows].sort((a, b) => {
    const left = value(a), right = value(b);
    if (missing(left) || missing(right)) return Number(missing(left)) - Number(missing(right));
    const comparison = typeof left === "number" && typeof right === "number"
      ? left - right : collator.compare(String(left), String(right));
    return direction === "ascending" ? comparison : -comparison;
  });
}
